<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p10"><span><a id="page_8"></a><a href="#/Contents#rp10">FISH STOCK</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="imagela"><span><img alt="" height="49" src="images/45ref.jpg" width="25"/></span></p>
<p class="normal"><span><i>Make arrangements with the fish department of your supermarket to save fish bones for you.</i></span></p>
<p class="make"><span>Makes about 1½ quarts</span></p>
<p class="hang"><span>2 quarts water</span></p>
<p class="hang"><span>2–3 pounds fish bones (from a non-oily fish, such as haddock)</span></p>
<p class="hang"><span>1 each: chopped large onion, rib celery</span></p>
<p class="hang"><span>2 bay leaves</span></p>
<p class="hang"><span>7–8 black peppercorns</span></p>
<p class="hang"><span>½ teaspoon each: kosher or sea salt, white pepper</span></p>
<p class="normalt"><span><b>1.</b> Heat all ingredients to boiling in large saucepan; reduce heat and simmer 30 minutes, skimming foam from surface. Strain through double layer of cheesecloth, discarding bones, vegetables, and seasonings.</span></p>
<p class="per"><span>Per Cup:</span></p>
<p class="per1"><span>Calories: 17</span></p>
<p class="per1"><span>% calories from fat: 0</span></p>
<p class="per1"><span>Protein (g): 2.8</span></p>
<p class="per1"><span>Carbohydrate (g): 0.3</span></p>
<p class="per1"><span>Fat (g): 0.1</span></p>
<p class="per1"><span>Saturated fat (g): 0</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 191</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 0.0</span></p>
<p class="per1"><span>Fruit: 0.0</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.0</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0110.vue?b459ad3c